const byValue = function(value, collection) {
  if (collection && collection.length > 0) {
    for (let ndx = 0; ndx < collection.length; ndx++) {
      let item = collection[ndx];
      if (item.value && item.value === value) {
        return item;
      }
    }
  }

  return null;
};

const tiposDocumento = [
  {
    value: "00",
    label: "DNI"
  },
  {
    value: "31",
    label: "DNE"
  }
];

const estadosCiviles = [
  {
    value: "1",
    label: "Casado/a"
  },
  {
    value: "2",
    label: "Viudo/a"
  },
  {
    value: "3",
    label: "Separado/a"
  },
  {
    value: "4",
    label: "Divorciado/a"
  },
  {
    value: "5",
    label: "Soltero/a"
  },
  {
    value: "6",
    label: "Concubinato"
  }
];

const provincias = [
  { value: "01", label: "CAPITAL FEDERAL" },
  { value: "02", label: "BUENOS AIRES" },
  { value: "03", label: "CATAMARCA" },
  { value: "04", label: "CORDOBA" },
  { value: "05", label: "CORRIENTES" },
  { value: "06", label: "CHACO" },
  { value: "07", label: "CHUBUT" },
  { value: "08", label: "ENTRE RIOS" },
  { value: "09", label: "FORMOSA" },
  { value: "10", label: "JUJUY" },
  { value: "11", label: "LA PAMPA" },
  { value: "12", label: "LA RIOJA" },
  { value: "13", label: "MENDOZA" },
  { value: "14", label: "MISIONES" },
  { value: "15", label: "NEUQUEN" },
  { value: "16", label: "RIO NEGRO" },
  { value: "17", label: "SALTA" },
  { value: "18", label: "SAN JUAN" },
  { value: "19", label: "SAN LUIS" },
  { value: "20", label: "SANTA CRUZ" },
  { value: "21", label: "SANTA FE" },
  { value: "22", label: "SANTIAGO DEL ESTERO" },
  { value: "40", label: "TIERRA DEL FUEGO" },
  { value: "23", label: "TUCUMAN" }
];

const situacionesLaborales = [
  {
    value: "001",
    oldValue: "0",
    label: "En rel. de dependencia"
  },
  {
    value: "002",
    oldValue: "1",
    label: "Contratado"
  },
  {
    value: "003",
    oldValue: "3",
    label: "Autónomo"
  },
  {
    value: "004",
    oldValue: "2",
    label: "Otro"
  }
];

const actividades = [
  {
    label: "ADMIN. PUBLICA",
    value: "24"
  },
  {
    label: "AGENCIA VIAJES,ALQUILER AUTO",
    value: "45"
  },
  {
    label: "AGRICULTURA",
    value: "01"
  },
  {
    label: "ALIMENTACION/TABACO",
    value: "14"
  },
  {
    label: "ALQUILER/VENTA INMUEBLES",
    value: "38"
  },
  {
    label: "ASESORIA,INGENIERIA,SERVICIOS",
    value: "32"
  },
  {
    label: "BANCA PRIVADA/FINAN/SEG.",
    value: "29"
  },
  {
    label: "BANCA PUBLICA/FINAN/SEG.",
    value: "30"
  },
  {
    label: "BEBIDAS",
    value: "15"
  },
  {
    label: "CAZA/SILVICULTURA",
    value: "02"
  },
  {
    label: "COMERCIO MAYORISTA",
    value: "34"
  },
  {
    label: "COMERCIO MINORISTA",
    value: "35"
  },
  {
    label: "CONSTRUCCCION Y MATERIALES CONS",
    value: "13"
  },
  {
    label: "CORREOS Y TELECOMUNICACIONES",
    value: "46"
  },
  {
    label: "CUERO/PIEL/CALZADO",
    value: "17"
  },
  {
    label: "DIPLOMATICOS-ORG.INTERNACIONALES",
    value: "26"
  },
  {
    label: "ELECTRICIDAD,ELECTRODOMESTICOS",
    value: "10"
  },
  {
    label: "ELECTRONICA,INFORMATICA ETC",
    value: "11"
  },
  {
    label: "ENERGIA,AGUA,GAS",
    value: "07"
  },
  {
    label: "ENSENANZA PRIVADA",
    value: "28"
  },
  {
    label: "ESPECTACULOS/DEPORTES",
    value: "40"
  },
  {
    label: "EXPLOT.MINAS/CANTERAS",
    value: "06"
  },
  {
    label: "EXPLOTACION Y SERV.AGROPECUARIOS",
    value: "03"
  },
  {
    label: "FAB VEHICULOS Y AUTOPARTES",
    value: "12"
  },
  {
    label: "FERROCARRIL",
    value: "44"
  },
  {
    label: "GANADERIA",
    value: "04"
  },
  {
    label: "HOTELERIA,RESTAURANTE",
    value: "36"
  },
  {
    label: "MADERA,CERAMICA,VIDRIO",
    value: "18"
  },
  {
    label: "MAQUINARIA,INGEN/MECANICA",
    value: "09"
  },
  {
    label: "METAL/SIDERURGIA",
    value: "08"
  },
  {
    label: "MILITAR-POLICIA",
    value: "25"
  },
  {
    label: "MUEBLES,JUGUETES Y ART.DEPORTIVOS",
    value: "19"
  },
  {
    label: "PAPEL/ARTES GRAFICAS",
    value: "20"
  },
  {
    label: "PESCA",
    value: "05"
  },
  {
    label: "PETROLEO",
    value: "22"
  },
  {
    label: "PRENSA/RADIO/TV",
    value: "39"
  },
  {
    label: "PRODUCTOS QUIMICOS/FARMACIA",
    value: "21"
  },
  {
    label: "REPARACION VEHICULOS/AUXILIO MECANICO",
    value: "37"
  },
  {
    label: "SALUD PRIVADA/VETERINARIA",
    value: "49"
  },
  {
    label: "SANIDAD,SERV.PUB/VETERINARIA",
    value: "27"
  },
  {
    label: "SEGURIDAD",
    value: "48"
  },
  {
    label: "SERV.DOMESTICOS Y PERSON.",
    value: "33"
  },
  {
    label: "SERV.INFORMATICOS,SOFTWARE",
    value: "31"
  },
  {
    label: "TEXTIL Y VESTIDO",
    value: "16"
  },
  {
    label: "TRANSPORTE AEREO",
    value: "42"
  },
  {
    label: "TRANSPORTE NAVAL",
    value: "43"
  },
  {
    label: "TRANSPORTE TERRESTRE",
    value: "41"
  },
  {
    label: "OTRAS INDUSTRIAS",
    value: "23"
  },
  {
    label: "OTROS SERVICIOS",
    value: "47"
  }
];

const ocupaciones = [
  {
    situacionLaboral: "003",
    label: "ABOGADO",
    value: "18"
  },
  {
    situacionLaboral: "003",
    label: "ACTIVIDADES AGROPECUARIAS",
    value: "28"
  },
  {
    situacionLaboral: "001",
    label: "ADMINISTRATIVO",
    value: "07"
  },
  {
    situacionLaboral: "001",
    label: "ALTOS FUNCIONARIOS PUBLICOS/DIPLOMATICOS",
    value: "06"
  },
  {
    situacionLaboral: "003",
    label: "ARQUITECTO/INGENIERO",
    value: "20"
  },
  {
    situacionLaboral: "003",
    label: "ARTISTA/DEPORTISTA PROFESIONAL",
    value: "24"
  },
  {
    situacionLaboral: "003",
    label: "ASESOR/CONSULTOR/AUDITOR/COMPUTACION",
    value: "29"
  },
  {
    situacionLaboral: "003",
    label: "BIOLOGO/CIENCIAS EXACTAS",
    value: "30"
  },
  {
    situacionLaboral: "003",
    label: "COMERCIANTE/EMPRESARIO/INDUSTRIAL",
    value: "25"
  },
  {
    situacionLaboral: "003",
    label: "CONTADOR/ECONOMISTA/ADMINISTRADOR",
    value: "26"
  },
  {
    situacionLaboral: "001",
    label: "DIPLOMATICOS ARGENTINOS",
    value: "46"
  },
  {
    situacionLaboral: "001",
    label: "DIPLOMATICOS EXTRANJEROS",
    value: "47"
  },
  {
    situacionLaboral: "001",
    label: "DOCENTE",
    value: "11"
  },
  {
    situacionLaboral: "001",
    label: "EMPLEADO PUBLICO(NO VIA PUBLICA NI SEGURIDAD)",
    value: "41"
  },
  {
    situacionLaboral: "001",
    label: "ENCARGADO",
    value: "12"
  },
  {
    situacionLaboral: "003",
    label: "ESCRIBANO/NOTARIO",
    value: "19"
  },
  {
    situacionLaboral: "003",
    label: "ESCRITOR/TRADUCTOR",
    value: "21"
  },
  {
    situacionLaboral: "003",
    label: "FARMACEUTICO",
    value: "23"
  },
  {
    situacionLaboral: "001",
    label: "GERENTE DE AREA/SUPERVISOR/TESORERO",
    value: "03"
  },
  {
    situacionLaboral: "001",
    label: "JEFE/MANDO INTERMEDIO/ADMINISTRADOR",
    value: "04"
  },
  {
    situacionLaboral: "001",
    label: "JUEZ/FISCAL/CATEDRATICO",
    value: "10"
  },
  {
    situacionLaboral: "001",
    label: "MEDICO ASALARIADO",
    value: "40"
  },
  {
    situacionLaboral: "003",
    label: "MEDICO/ODONTOLOGO",
    value: "17"
  },
  {
    situacionLaboral: "001",
    label: "MILITAR/POLICIA(OFICIAL/RANGOS SUPERIORES)",
    value: "08"
  },
  {
    situacionLaboral: "001",
    label: "MILITAR/POLICIA(RANGOS INFERIORES)",
    value: "09"
  },
  {
    situacionLaboral: "001",
    label: "OBRERO / OPERARIO",
    value: "14"
  },
  {
    situacionLaboral: "001",
    label: "OBRERO CALIFICADO / OPERARIO CALIFICADO",
    value: "13"
  },
  {
    situacionLaboral: "003",
    label: "OFICIOS:ELECTRICISTA,PLOMERO,ETC",
    value: "27"
  },
  {
    situacionLaboral: "001",
    label: "PERIODISTA",
    value: "45"
  },
  {
    situacionLaboral: "003",
    label: "PERIODISTA/ESCRITOR/GUIONISTA",
    value: "43"
  },
  {
    situacionLaboral: "003",
    label: "POLITICO",
    value: "42"
  },
  {
    situacionLaboral: "001",
    label: "PRESIDENTE/GERENTE GRAL/GERENTE EJECUTIVO",
    value: "01"
  },
  {
    situacionLaboral: "001",
    label: "PROFESIONAL TECNICO",
    value: "05"
  },
  {
    situacionLaboral: "003",
    label: "PSICOLOGO",
    value: "44"
  },
  {
    situacionLaboral: "001",
    label: "SEGURIDAD/INVESTIGACION/DETECTIVE",
    value: "37"
  },
  {
    situacionLaboral: "001",
    label: "VENDEDOR (NO EN VIA PUBLICA)",
    value: "15"
  },
  {
    situacionLaboral: "003",
    label: "VETERINARIO",
    value: "22"
  },
  {
    situacionLaboral: "001",
    label: "VICEPRESIDENTE/DIRECTOR/SOCIO",
    value: "02"
  },
  {
    situacionLaboral: "001",
    label: "OTROS ASALARIADOS",
    value: "16"
  },
  {
    situacionLaboral: "003",
    label: "OTROS INDEPENDIENTES",
    value: "31"
  }
];

const ingresosNetos = [
  {
    value: "4500",
    label: "Menos de $10.000"
  },
  {
    value: "10001",
    label: "$10.000 - $15.000"
  },
  {
    value: "15001",
    label: "$15.000 - $25.000"
  },
  {
    value: "+25001",
    label: "Más de $25.000"
  }
];

const sucursales = [
  {
    numeroSucursal: "0008",
    provincia: "GRAN BUENOS AIRES",
    localidad: "MORON",
    descripcionSucursal: "MORON UNIVERSIDAD",
    direccionSucursal: "MACHADO 815",
    idSucursal: "0008"
  },
  {
    numeroSucursal: "0011",
    provincia: "GRAN BUENOS AIRES",
    localidad: "MERCEDES",
    descripcionSucursal: "MERCEDES",
    direccionSucursal: "AV. 29 NRO 493",
    idSucursal: "0011"
  },
  {
    numeroSucursal: "0001",
    provincia: "CAPITAL FEDERAL",
    localidad: "PARQUE CHACABUCO",
    descripcionSucursal: "ASAMBLEA",
    direccionSucursal: "AV. ASAMBLEA 695",
    idSucursal: "0001"
  },
  {
    numeroSucursal: "0013",
    provincia: "GRAN BUENOS AIRES",
    localidad: "SAN FERNANDO",
    descripcionSucursal: "SAN FERNANDO",
    direccionSucursal: "CONSTITUCION 1",
    idSucursal: "0013"
  },
  {
    numeroSucursal: "0003",
    provincia: "CAPITAL FEDERAL",
    localidad: "BOCA",
    descripcionSucursal: "BOCA",
    direccionSucursal: "AV. ALMIRANTE BROWN 826",
    idSucursal: "0003"
  },
  {
    numeroSucursal: "0014",
    provincia: "GRAN BUENOS AIRES",
    localidad: "SAN JUSTO",
    descripcionSucursal: "SAN JUSTO",
    direccionSucursal: "VILLEGAS 2429",
    idSucursal: "0014"
  },
  {
    numeroSucursal: "0004",
    provincia: "CAPITAL FEDERAL",
    localidad: "BOEDO",
    descripcionSucursal: "BOEDO",
    direccionSucursal: "AV. SAN JUAN 3599",
    idSucursal: "0004"
  },
  {
    numeroSucursal: "0005",
    provincia: "CAPITAL FEDERAL",
    localidad: "SAN NICOLAS",
    descripcionSucursal: "OBELISCO",
    direccionSucursal: "AV. CORRIENTES 1102",
    idSucursal: "0005"
  },
  {
    numeroSucursal: "0006",
    provincia: "CAPITAL FEDERAL",
    localidad: "CONSTITUCION",
    descripcionSucursal: "CONSTITUCION",
    direccionSucursal: "BERNARDO DE IRIGOYEN 1600",
    idSucursal: "0006"
  },
  {
    numeroSucursal: "0015",
    provincia: "GRAN BUENOS AIRES",
    localidad: "SAN MARTIN",
    descripcionSucursal: "SAN MARTIN",
    direccionSucursal: "CALLE 91 NRO 2160-68",
    idSucursal: "0015"
  },
  {
    numeroSucursal: "0018",
    provincia: "GRAN BUENOS AIRES",
    localidad: "VILLA LYNCH",
    descripcionSucursal: "VILLA LYNCH",
    direccionSucursal: "REPUBLICA DEL LIBANO 247",
    idSucursal: "0018"
  },
  {
    numeroSucursal: "0007",
    provincia: "CAPITAL FEDERAL",
    localidad: "ABASTO",
    descripcionSucursal: "ABASTO",
    direccionSucursal: "AV. CORRIENTES 3399 ESQ. GALLO",
    idSucursal: "0007"
  },
  {
    numeroSucursal: "0010",
    provincia: "CAPITAL FEDERAL",
    localidad: "NUEVA POMPEYA",
    descripcionSucursal: "NUEVA POMPEYA",
    direccionSucursal: "AV. SAENZ 1146",
    idSucursal: "0010"
  },
  {
    numeroSucursal: "0012",
    provincia: "CAPITAL FEDERAL",
    localidad: "PARQUE PATRICIOS",
    descripcionSucursal: "PATRICIOS",
    direccionSucursal: "RONDEAU 3002",
    idSucursal: "0012"
  },
  {
    numeroSucursal: "0016",
    provincia: "CAPITAL FEDERAL",
    localidad: "BELGRANO",
    descripcionSucursal: "BELGRANO C",
    direccionSucursal: "AV. DEL LIBERTADOR 6220",
    idSucursal: "0016"
  },
  {
    numeroSucursal: "0017",
    provincia: "CAPITAL FEDERAL",
    localidad: "RECOLETA",
    descripcionSucursal: "BARRIO NORTE",
    direccionSucursal: "AV. SANTA FE 1630",
    idSucursal: "0017"
  },
  {
    numeroSucursal: "0023",
    provincia: "CAPITAL FEDERAL",
    localidad: "RECOLETA",
    descripcionSucursal: "RECOLETA",
    direccionSucursal: "AV. CALLAO 1499",
    idSucursal: "0023"
  },
  {
    numeroSucursal: "0025",
    provincia: "CAPITAL FEDERAL",
    localidad: "FLORESTA",
    descripcionSucursal: "FLORESTA",
    direccionSucursal: "AV. J.B.JUSTO 7132",
    idSucursal: "0025"
  },
  {
    numeroSucursal: "0019",
    provincia: "GRAN BUENOS AIRES",
    localidad: "VILLA DOMINICO",
    descripcionSucursal: "VILLA DOMINICO",
    direccionSucursal: "AV. MITRE 4165/69",
    idSucursal: "0019"
  },
  {
    numeroSucursal: "0026",
    provincia: "CAPITAL FEDERAL",
    localidad: "PALERMO",
    descripcionSucursal: "PALERMO",
    direccionSucursal: "AV. SANTA FE 5000",
    idSucursal: "0026"
  },
  {
    numeroSucursal: "0032",
    provincia: "CAPITAL FEDERAL",
    localidad: "BARRACAS",
    descripcionSucursal: "MONTES DE OCA",
    direccionSucursal: "AV. MONTES DE OCA 1107",
    idSucursal: "0032"
  },
  {
    numeroSucursal: "0035",
    provincia: "CAPITAL FEDERAL",
    localidad: "VILLA CRESPO",
    descripcionSucursal: "VILLA CRESPO",
    direccionSucursal: "AV. CORDOBA 4675/77",
    idSucursal: "0035"
  },
  {
    numeroSucursal: "0038",
    provincia: "CAPITAL FEDERAL",
    localidad: "PATERNAL",
    descripcionSucursal: "PATERNAL",
    direccionSucursal: "AV. SAN MARTIN 2349",
    idSucursal: "0038"
  },
  {
    numeroSucursal: "0039",
    provincia: "CAPITAL FEDERAL",
    localidad: "SAN NICOLAS",
    descripcionSucursal: "PLAZA ROMA",
    direccionSucursal: "TUCUMAN 101",
    idSucursal: "0039"
  },
  {
    numeroSucursal: "0020",
    provincia: "GRAN BUENOS AIRES",
    localidad: "LLAVALLOL",
    descripcionSucursal: "LLAVALLOL",
    direccionSucursal: "AV.ANTARTIDA ARG.1770/76",
    idSucursal: "0020"
  },
  {
    numeroSucursal: "0042",
    provincia: "CAPITAL FEDERAL",
    localidad: "VILLA GENERAL MITRE",
    descripcionSucursal: "NAZCA",
    direccionSucursal: "AV. NAZCA 1922",
    idSucursal: "0042"
  },
  {
    numeroSucursal: "0022",
    provincia: "GRAN BUENOS AIRES",
    localidad: "LOMAS DEL MIRADOR",
    descripcionSucursal: "LOMAS DEL MIRADOR",
    direccionSucursal: "AV. MOSCONI 1149",
    idSucursal: "0022"
  },
  {
    numeroSucursal: "0027",
    provincia: "GRAN BUENOS AIRES",
    localidad: "LANUS",
    descripcionSucursal: "LANUS ESTE",
    direccionSucursal: "AV. 9 DE JULIO 2090",
    idSucursal: "0027"
  },
  {
    numeroSucursal: "0028",
    provincia: "GRAN BUENOS AIRES",
    localidad: "BERNAL",
    descripcionSucursal: "BERNAL",
    direccionSucursal: "AV.CRISOLOGO LARRALDE 800",
    idSucursal: "0028"
  },
  {
    numeroSucursal: "0030",
    provincia: "GRAN BUENOS AIRES",
    localidad: "GERLI",
    descripcionSucursal: "GERLI",
    direccionSucursal: "LACARRA 1585",
    idSucursal: "0030"
  },
  {
    numeroSucursal: "0043",
    provincia: "CAPITAL FEDERAL",
    localidad: "MONSERRAT",
    descripcionSucursal: "AV. ENTRE RIOS",
    direccionSucursal: "AV. ENTRE RIOS 466/70",
    idSucursal: "0043"
  },
  {
    numeroSucursal: "0037",
    provincia: "GRAN BUENOS AIRES",
    localidad: "VILLA ADELINA",
    descripcionSucursal: "VILLA ADELINA",
    direccionSucursal: "PARANA 6552",
    idSucursal: "0037"
  },
  {
    numeroSucursal: "0044",
    provincia: "CAPITAL FEDERAL",
    localidad: "MONSERRAT",
    descripcionSucursal: "PIEDRAS",
    direccionSucursal: "AV. DE MAYO 782",
    idSucursal: "0044"
  },
  {
    numeroSucursal: "0051",
    provincia: "CAPITAL FEDERAL",
    localidad: "CAPITAL FEDERAL",
    descripcionSucursal: "ARROYO",
    direccionSucursal: "CARLOS PELLEGRINI 1413",
    idSucursal: "0051"
  },
  {
    numeroSucursal: "0052",
    provincia: "CAPITAL FEDERAL",
    localidad: "CAPITAL FEDERAL",
    descripcionSucursal: "LE PARC",
    direccionSucursal: "AV. CERVINO 4648",
    idSucursal: "0052"
  },
  {
    numeroSucursal: "0058",
    provincia: "GRAN BUENOS AIRES",
    localidad: "MERLO",
    descripcionSucursal: "MERLO",
    direccionSucursal: "AV. LIBERTADOR 323",
    idSucursal: "0058"
  },
  {
    numeroSucursal: "0061",
    provincia: "SANTA CRUZ",
    localidad: "CIUDAD DE LAS HERAS",
    descripcionSucursal: "LAS HERAS",
    direccionSucursal: "PERITO MORENO 348",
    idSucursal: "0061"
  },
  {
    numeroSucursal: "0062",
    provincia: "GRAN BUENOS AIRES",
    localidad: "Chascomus",
    descripcionSucursal: "CHASCOMUS",
    direccionSucursal: "LIBRES DEL SUR NRO: 112",
    idSucursal: "0062"
  },
  {
    numeroSucursal: "0056",
    provincia: "CAPITAL FEDERAL",
    localidad: "BOCA",
    descripcionSucursal: "MARTIN GARCIA",
    direccionSucursal: "AV. MARTIN GARCIA 702",
    idSucursal: "0056"
  },
  {
    numeroSucursal: "0099",
    provincia: "CAPITAL FEDERAL",
    localidad: "SAN NICOLAS",
    descripcionSucursal: "CENTRO",
    direccionSucursal: "RECONQUISTA 199",
    idSucursal: "0099"
  },
  {
    numeroSucursal: "0101",
    provincia: "CAPITAL FEDERAL",
    localidad: "BELGRANO",
    descripcionSucursal: "AV. CABILDO",
    direccionSucursal: "AV. CABILDO 1732/40",
    idSucursal: "0101"
  },
  {
    numeroSucursal: "0065",
    provincia: "MISIONES",
    localidad: "OBERA",
    descripcionSucursal: "OBERA",
    direccionSucursal: "AV. SARMIENTO 950",
    idSucursal: "0065"
  },
  {
    numeroSucursal: "0105",
    provincia: "CAPITAL FEDERAL",
    localidad: "VILLA DEL PARQUE",
    descripcionSucursal: "VILLA DEL PARQUE",
    direccionSucursal: "NOGOYA 3256",
    idSucursal: "0105"
  },
  {
    numeroSucursal: "0066",
    provincia: "SANTA FE",
    localidad: "ROSARIO",
    descripcionSucursal: "FISHERTON",
    direccionSucursal: "AV. EVA PERON 7461",
    idSucursal: "0066"
  },
  {
    numeroSucursal: "0106",
    provincia: "CAPITAL FEDERAL",
    localidad: "ALMAGRO",
    descripcionSucursal: "PARQUE CENTENARIO",
    direccionSucursal: "AV. CORRIENTES 4694",
    idSucursal: "0106"
  },
  {
    numeroSucursal: "0068",
    provincia: "ENTRE RIOS",
    localidad: "CONCORDIA",
    descripcionSucursal: "CONCORDIA",
    direccionSucursal: "ENTRE RIOS 640",
    idSucursal: "0068"
  },
  {
    numeroSucursal: "0070",
    provincia: "TUCUMAN",
    localidad: "S.M.DE TUCUMAN",
    descripcionSucursal: "TUCUMAN NORTE",
    direccionSucursal: "SANTA FE 596",
    idSucursal: "0070"
  },
  {
    numeroSucursal: "0107",
    provincia: "CAPITAL FEDERAL",
    localidad: "VILLA LURO",
    descripcionSucursal: "MONTE CASTRO",
    direccionSucursal: "ALVAREZ JONTE 5255",
    idSucursal: "0107"
  },
  {
    numeroSucursal: "0071",
    provincia: "SANTIAGO DEL ESTERO",
    localidad: "SGO.DEL ESTERO",
    descripcionSucursal: "SANTIAGO DEL ESTERO",
    direccionSucursal: "24 DE SETIEMBRE 199",
    idSucursal: "0071"
  },
  {
    numeroSucursal: "0072",
    provincia: "SAN JUAN",
    localidad: "SAN JUAN",
    descripcionSucursal: "SAN JUAN",
    direccionSucursal: "RIVADAVIA 56",
    idSucursal: "0072"
  },
  {
    numeroSucursal: "0074",
    provincia: "ENTRE RIOS",
    localidad: "PARANA",
    descripcionSucursal: "PARANA",
    direccionSucursal: "SAN MARTIN 763",
    idSucursal: "0074"
  },
  {
    numeroSucursal: "0108",
    provincia: "CAPITAL FEDERAL",
    localidad: "PALERMO",
    descripcionSucursal: "CORONEL DIAZ",
    direccionSucursal: "AV. CORONEL DIAZ 2257",
    idSucursal: "0108"
  },
  {
    numeroSucursal: "0111",
    provincia: "CAPITAL FEDERAL",
    localidad: "ONCE",
    descripcionSucursal: "ONCE",
    direccionSucursal: "AV. CORRIENTES 2243",
    idSucursal: "0111"
  },
  {
    numeroSucursal: "0075",
    provincia: "ENTRE RIOS",
    localidad: "GUALEGUAYCHU",
    descripcionSucursal: "GUALEGUAYCHU",
    direccionSucursal: "25 DE MAYO 944",
    idSucursal: "0075"
  },
  {
    numeroSucursal: "0114",
    provincia: "CAPITAL FEDERAL",
    localidad: "DEVOTO",
    descripcionSucursal: "AVENIDA BEIRO",
    direccionSucursal: "AV. FCO. BEIRO 4359/61",
    idSucursal: "0114"
  },
  {
    numeroSucursal: "0116",
    provincia: "CAPITAL FEDERAL",
    localidad: "RETIRO",
    descripcionSucursal: "CANCILLERIA",
    direccionSucursal: "AV. SANTA FE 946",
    idSucursal: "0116"
  },
  {
    numeroSucursal: "0076",
    provincia: "CORRIENTES",
    localidad: "PASO DE LOS LIBRES",
    descripcionSucursal: "PASO DE LOS LIBRES",
    direccionSucursal: "COLON 794",
    idSucursal: "0076"
  },
  {
    numeroSucursal: "0077",
    provincia: "GRAN BUENOS AIRES",
    localidad: "TANDIL",
    descripcionSucursal: "TANDIL",
    direccionSucursal: "PINTO 771",
    idSucursal: "0077"
  },
  {
    numeroSucursal: "0078",
    provincia: "GRAN BUENOS AIRES",
    localidad: "SAN PEDRO",
    descripcionSucursal: "SAN PEDRO",
    direccionSucursal: "BARTOLOME MITRE 955",
    idSucursal: "0078"
  },
  {
    numeroSucursal: "0079",
    provincia: "GRAN BUENOS AIRES",
    localidad: "SAN NICOLAS",
    descripcionSucursal: "SAN NICOLAS",
    direccionSucursal: "BARTOLOME MITRE 215/7",
    idSucursal: "0079"
  },
  {
    numeroSucursal: "0080",
    provincia: "GRAN BUENOS AIRES",
    localidad: "BAHIA BLANCA",
    descripcionSucursal: "BAHIA BLANCA",
    direccionSucursal: "CHICLANA 63",
    idSucursal: "0080"
  },
  {
    numeroSucursal: "0081",
    provincia: "SANTA FE",
    localidad: "ROSARIO",
    descripcionSucursal: "ROSARIO",
    direccionSucursal: "CORDOBA 1039 ESQ. SARMIENTO",
    idSucursal: "0081"
  },
  {
    numeroSucursal: "0117",
    provincia: "CAPITAL FEDERAL",
    localidad: "ALMAGRO",
    descripcionSucursal: "CASTRO BARROS",
    direccionSucursal: "AV. RIVADAVIA 4059",
    idSucursal: "0117"
  },
  {
    numeroSucursal: "0082",
    provincia: "GRAN BUENOS AIRES",
    localidad: "CHIVILCOY",
    descripcionSucursal: "CHIVILCOY",
    direccionSucursal: "CARLOS PELLEGRINI 102",
    idSucursal: "0082"
  },
  {
    numeroSucursal: "0083",
    provincia: "RIO NEGRO",
    localidad: "GRAL.ROCA",
    descripcionSucursal: "GENERAL ROCA",
    direccionSucursal: "TUCUMAN 699",
    idSucursal: "0083"
  },
  {
    numeroSucursal: "0084",
    provincia: "CORDOBA",
    localidad: "CORDOBA",
    descripcionSucursal: "CORDOBA",
    direccionSucursal: "25 DE MAYO 280",
    idSucursal: "0084"
  },
  {
    numeroSucursal: "0085",
    provincia: "MENDOZA",
    localidad: "MENDOZA",
    descripcionSucursal: "MENDOZA",
    direccionSucursal: "SAN MARTIN 936",
    idSucursal: "0085"
  },
  {
    numeroSucursal: "0118",
    provincia: "CAPITAL FEDERAL",
    localidad: "SAN TELMO",
    descripcionSucursal: "SAN TELMO 1",
    direccionSucursal: "PASEO COLON 505",
    idSucursal: "0118"
  },
  {
    numeroSucursal: "0120",
    provincia: "CAPITAL FEDERAL",
    localidad: "VILLA URQUIZA",
    descripcionSucursal: "VILLA URQUIZA",
    direccionSucursal: "AV. TRIUNVIRATO 5201",
    idSucursal: "0120"
  },
  {
    numeroSucursal: "0087",
    provincia: "SALTA",
    localidad: "SALTA",
    descripcionSucursal: "SALTA",
    direccionSucursal: "ESPANA 642",
    idSucursal: "0087"
  },
  {
    numeroSucursal: "0089",
    provincia: "NEUQUEN",
    localidad: "NEUQUEN",
    descripcionSucursal: "NEUQUEN",
    direccionSucursal: "CARLOS RODRIGUEZ 48",
    idSucursal: "0089"
  },
  {
    numeroSucursal: "0123",
    provincia: "CAPITAL FEDERAL",
    localidad: "PUERTO MADERO",
    descripcionSucursal: "PUERTO MADERO",
    direccionSucursal: "A.M. DE JUSTO 868",
    idSucursal: "0123"
  },
  {
    numeroSucursal: "0124",
    provincia: "CAPITAL FEDERAL",
    localidad: "CABALLITO",
    descripcionSucursal: "CABALLITO",
    direccionSucursal: "AV. RIVADAVIA 5300",
    idSucursal: "0124"
  },
  {
    numeroSucursal: "0090",
    provincia: "GRAN BUENOS AIRES",
    localidad: "MAR DEL PLATA",
    descripcionSucursal: "MAR DEL PLATA -INDEPEND",
    direccionSucursal: "INDEPENDENCIA 2650",
    idSucursal: "0090"
  },
  {
    numeroSucursal: "0091",
    provincia: "GRAN BUENOS AIRES",
    localidad: "PERGAMINO",
    descripcionSucursal: "PERGAMINO",
    direccionSucursal: "SAN NICOLAS 649",
    idSucursal: "0091"
  },
  {
    numeroSucursal: "0093",
    provincia: "GRAN BUENOS AIRES",
    localidad: "LA PLATA",
    descripcionSucursal: "LA PLATA",
    direccionSucursal: "CALLE 47 NRO 641",
    idSucursal: "0093"
  },
  {
    numeroSucursal: "0094",
    provincia: "GRAN BUENOS AIRES",
    localidad: "MAR DEL PLATA",
    descripcionSucursal: "MAR DEL PLATA-CENTRO",
    direccionSucursal: "AV. LURO 3157 ESQ. CATAMARCA",
    idSucursal: "0094"
  },
  {
    numeroSucursal: "0097",
    provincia: "CHUBUT",
    localidad: "COMODORO RIVADAVIA",
    descripcionSucursal: "COMODORO RIVADAVIA",
    direccionSucursal: "SAN MARTIN 302",
    idSucursal: "0097"
  },
  {
    numeroSucursal: "0109",
    provincia: "GRAN BUENOS AIRES",
    localidad: "QUILMES",
    descripcionSucursal: "QUILMES",
    direccionSucursal: "ALSINA 216",
    idSucursal: "0109"
  },
  {
    numeroSucursal: "0110",
    provincia: "GRAN BUENOS AIRES",
    localidad: "LA PLATA",
    descripcionSucursal: "CALLE 12",
    direccionSucursal: "CALLE 12 NRO 1081",
    idSucursal: "0110"
  },
  {
    numeroSucursal: "0126",
    provincia: "CAPITAL FEDERAL",
    localidad: "FLORES",
    descripcionSucursal: "FLORES",
    direccionSucursal: "AV. RIVADAVIA 6483/87",
    idSucursal: "0126"
  },
  {
    numeroSucursal: "0135",
    provincia: "CAPITAL FEDERAL",
    localidad: "CABALLITO",
    descripcionSucursal: "SCALABRINI ORTIZ",
    direccionSucursal: "AV. CORRIENTES 5117",
    idSucursal: "0135"
  },
  {
    numeroSucursal: "0137",
    provincia: "CAPITAL FEDERAL",
    localidad: "VILLA LUGANO",
    descripcionSucursal: "VILLA LUGANO",
    direccionSucursal: "SAYOS 5717",
    idSucursal: "0137"
  },
  {
    numeroSucursal: "0113",
    provincia: "GRAN BUENOS AIRES",
    localidad: "GENERAL PACHECO",
    descripcionSucursal: "TALAR DE PACHECO",
    direccionSucursal: "HIPOLITO YRIGOYEN 921",
    idSucursal: "0113"
  },
  {
    numeroSucursal: "0141",
    provincia: "CAPITAL FEDERAL",
    localidad: "CAPITAL FEDERAL",
    descripcionSucursal: "PUERTO MADERO ESTE",
    direccionSucursal: "JUANA MANSO 1124 PB",
    idSucursal: "0141"
  },
  {
    numeroSucursal: "0119",
    provincia: "ENTRE RIOS",
    localidad: "COLON",
    descripcionSucursal: "COLON",
    direccionSucursal: "12 DE ABRIL 342/350",
    idSucursal: "0119"
  },
  {
    numeroSucursal: "0121",
    provincia: "GRAN BUENOS AIRES",
    localidad: "MUNRO",
    descripcionSucursal: "MUNRO",
    direccionSucursal: "AV. VELEZ SARFIELD 5250",
    idSucursal: "0121"
  },
  {
    numeroSucursal: "0128",
    provincia: "GRAN BUENOS AIRES",
    localidad: "LA PLATA",
    descripcionSucursal: "LA PLATA NORTE",
    direccionSucursal: "CALLE 7 NRO. 21",
    idSucursal: "0128"
  },
  {
    numeroSucursal: "0130",
    provincia: "GRAN BUENOS AIRES",
    localidad: "MORENO",
    descripcionSucursal: "MORENO",
    direccionSucursal: "ESPANA 203",
    idSucursal: "0130"
  },
  {
    numeroSucursal: "0132",
    provincia: "GRAN BUENOS AIRES",
    localidad: "FLORENCIO VARELA",
    descripcionSucursal: "FLORENCIO VARELA",
    direccionSucursal: "A.J.VAZQUEZ ESQ.S.MARTIN",
    idSucursal: "0132"
  },
  {
    numeroSucursal: "0133",
    provincia: "GRAN BUENOS AIRES",
    localidad: "PILAR",
    descripcionSucursal: "PARQUE INDUSTRIAL PILAR",
    direccionSucursal: "CALLE 9 NRO 1761",
    idSucursal: "0133"
  },
  {
    numeroSucursal: "0143",
    provincia: "CAPITAL FEDERAL",
    localidad: "FLORESTA",
    descripcionSucursal: "PLAZA VELEZ SARFIELD",
    direccionSucursal: "AVENIDA GAONA 3720",
    idSucursal: "0143"
  },
  {
    numeroSucursal: "0136",
    provincia: "GRAN BUENOS AIRES",
    localidad: "LAFERRERE",
    descripcionSucursal: "GREGORIO DE LAFERRERE",
    direccionSucursal: "AV. LURO 5960",
    idSucursal: "0136"
  },
  {
    numeroSucursal: "0140",
    provincia: "GRAN BUENOS AIRES",
    localidad: "BURZACO",
    descripcionSucursal: "BURZACO",
    direccionSucursal: "ROCA 1097",
    idSucursal: "0140"
  },
  {
    numeroSucursal: "0142",
    provincia: "GRAN BUENOS AIRES",
    localidad: "EZEIZA",
    descripcionSucursal: "EZEIZA",
    direccionSucursal: "RAFAEL RAMOS MEJIA 173",
    idSucursal: "0142"
  },
  {
    numeroSucursal: "0144",
    provincia: "GRAN BUENOS AIRES",
    localidad: "CAMPANA",
    descripcionSucursal: "CAMPANA",
    direccionSucursal: "ING. AGUSTIN ROCA 93",
    idSucursal: "0144"
  },
  {
    numeroSucursal: "0147",
    provincia: "GRAN BUENOS AIRES",
    localidad: "VILLA MARTELLI",
    descripcionSucursal: "VILLA MARTELLI",
    direccionSucursal: "LAPRIDA 3943",
    idSucursal: "0147"
  },
  {
    numeroSucursal: "0150",
    provincia: "GRAN BUENOS AIRES",
    localidad: "VALENTIN ALSINA",
    descripcionSucursal: "VALENTIN ALSINA",
    direccionSucursal: "PRESIDENTE PERON 2675/9",
    idSucursal: "0150"
  },
  {
    numeroSucursal: "0151",
    provincia: "GRAN BUENOS AIRES",
    localidad: "EL PALOMAR",
    descripcionSucursal: "EL PALOMAR",
    direccionSucursal: "ITACUMBU 664",
    idSucursal: "0151"
  },
  {
    numeroSucursal: "0154",
    provincia: "GRAN BUENOS AIRES",
    localidad: "SAN ISIDRO",
    descripcionSucursal: "SAN ISIDRO CENTRO",
    direccionSucursal: "25 DE MAYO 193",
    idSucursal: "0154"
  },
  {
    numeroSucursal: "0156",
    provincia: "GRAN BUENOS AIRES",
    localidad: "CASEROS",
    descripcionSucursal: "CASEROS CENTRO",
    direccionSucursal: "AV. SAN MARTIN 2593",
    idSucursal: "0156"
  },
  {
    numeroSucursal: "0149",
    provincia: "CAPITAL FEDERAL",
    localidad: "FLORES",
    descripcionSucursal: "PLAZA IRLANDA",
    direccionSucursal: "AV. GAONA 2508",
    idSucursal: "0149"
  },
  {
    numeroSucursal: "0167",
    provincia: "GRAN BUENOS AIRES",
    localidad: "ADROGUE",
    descripcionSucursal: "ADROGUE",
    direccionSucursal: "ESTEBAN ADROGUE 1029",
    idSucursal: "0167"
  },
  {
    numeroSucursal: "0169",
    provincia: "GRAN BUENOS AIRES",
    localidad: "HAEDO",
    descripcionSucursal: "HAEDO",
    direccionSucursal: "AV. RIVADAVIA 16267",
    idSucursal: "0169"
  },
  {
    numeroSucursal: "0170",
    provincia: "GRAN BUENOS AIRES",
    localidad: "RAMOS MEJIA",
    descripcionSucursal: "RAMOS MEJIA",
    direccionSucursal: "AV. DE MAYO 149/151",
    idSucursal: "0170"
  },
  {
    numeroSucursal: "0171",
    provincia: "GRAN BUENOS AIRES",
    localidad: "TIGRE",
    descripcionSucursal: "TIGRE",
    direccionSucursal: "CAZON 1374",
    idSucursal: "0171"
  },
  {
    numeroSucursal: "0177",
    provincia: "GRAN BUENOS AIRES",
    localidad: "BERISSO",
    descripcionSucursal: "BERISSO",
    direccionSucursal: "MONTEVIDEO 601",
    idSucursal: "0177"
  },
  {
    numeroSucursal: "0180",
    provincia: "GRAN BUENOS AIRES",
    localidad: "ENSENADA",
    descripcionSucursal: "ENSENADA",
    direccionSucursal: "LA MERCED 198",
    idSucursal: "0180"
  },
  {
    numeroSucursal: "0181",
    provincia: "GRAN BUENOS AIRES",
    localidad: "WILDE",
    descripcionSucursal: "WILDE",
    direccionSucursal: "AV. MITRE 6250/52",
    idSucursal: "0181"
  },
  {
    numeroSucursal: "0183",
    provincia: "GRAN BUENOS AIRES",
    localidad: "CITY BELL",
    descripcionSucursal: "CITY BELL",
    direccionSucursal: "PLAZA BELGRANO 101",
    idSucursal: "0183"
  },
  {
    numeroSucursal: "0155",
    provincia: "CAPITAL FEDERAL",
    localidad: "SAN NICOLAS",
    descripcionSucursal: "DIAGONAL",
    direccionSucursal: "ESMERALDA 199",
    idSucursal: "0155"
  },
  {
    numeroSucursal: "0165",
    provincia: "CAPITAL FEDERAL",
    localidad: "PALERMO",
    descripcionSucursal: "ANCHORENA",
    direccionSucursal: "AV. SANTA FE 2699",
    idSucursal: "0165"
  },
  {
    numeroSucursal: "0188",
    provincia: "GRAN BUENOS AIRES",
    localidad: "MONTE GRANDE",
    descripcionSucursal: "MONTE GRANDE",
    direccionSucursal: "SANTAMARINA 476-78",
    idSucursal: "0188"
  },
  {
    numeroSucursal: "0189",
    provincia: "GRAN BUENOS AIRES",
    localidad: "CASTELAR",
    descripcionSucursal: "CASTELAR",
    direccionSucursal: "AV. I. ARIAS 2425",
    idSucursal: "0189"
  },
  {
    numeroSucursal: "0191",
    provincia: "GRAN BUENOS AIRES",
    localidad: "GRAL.RODRIGUEZ",
    descripcionSucursal: "GRAL.RODRIGUEZ",
    direccionSucursal: "AV. SAN MARTIN 98",
    idSucursal: "0191"
  },
  {
    numeroSucursal: "0193",
    provincia: "GRAN BUENOS AIRES",
    localidad: "NORDELTA",
    descripcionSucursal: "NORDELTA",
    direccionSucursal: "AV.DE LOS LAGOS 6660 (C.COM.LOC.11 Y 12)",
    idSucursal: "0193"
  },
  {
    numeroSucursal: "0195",
    provincia: "GRAN BUENOS AIRES",
    localidad: "TORTUGUITAS",
    descripcionSucursal: "TORTUGAS OPEN MALL",
    direccionSucursal: "CONSTITUYENTES Y AUT PANAMERIC ACC NORTE",
    idSucursal: "0195"
  },
  {
    numeroSucursal: "0199",
    provincia: "GRAN BUENOS AIRES",
    localidad: "TEMPERLEY",
    descripcionSucursal: "TEMPERLEY",
    direccionSucursal: "HIPOLITO YRIGOYEN 10.598",
    idSucursal: "0199"
  },
  {
    numeroSucursal: "0201",
    provincia: "SANTA FE",
    localidad: "ROSARIO",
    descripcionSucursal: "ARROYITO",
    direccionSucursal: "AV. ALBERDI 863",
    idSucursal: "0201"
  },
  {
    numeroSucursal: "0202",
    provincia: "CORDOBA",
    localidad: "CORDOBA",
    descripcionSucursal: "CORDOBA CENTRO",
    direccionSucursal: "BUENOS AIRES 1",
    idSucursal: "0202"
  },
  {
    numeroSucursal: "0166",
    provincia: "CAPITAL FEDERAL",
    localidad: "SAN NICOLAS",
    descripcionSucursal: "GALERIAS PACIFICO",
    direccionSucursal: "FLORIDA 802",
    idSucursal: "0166"
  },
  {
    numeroSucursal: "0206",
    provincia: "SANTA CRUZ",
    localidad: "CALETA OLIVIA",
    descripcionSucursal: "CALETA OLIVIA",
    direccionSucursal: "EVA PERON 340(ESQUINA SALVADOR GAVIOTA)",
    idSucursal: "0206"
  },
  {
    numeroSucursal: "0207",
    provincia: "SANTA FE",
    localidad: "RAFAELA",
    descripcionSucursal: "RAFAELA",
    direccionSucursal: "BOULEVARD LEHMAN 148",
    idSucursal: "0207"
  },
  {
    numeroSucursal: "0173",
    provincia: "CAPITAL FEDERAL",
    localidad: "CABALLITO",
    descripcionSucursal: "AV. LA PLATA",
    direccionSucursal: "AV. LA PLATA 1805",
    idSucursal: "0173"
  },
  {
    numeroSucursal: "0209",
    provincia: "SANTA FE",
    localidad: "ROSARIO",
    descripcionSucursal: "TIRO SUIZO",
    direccionSucursal: "SAN MARTIN 5091/99",
    idSucursal: "0209"
  },
  {
    numeroSucursal: "0210",
    provincia: "SANTA FE",
    localidad: "SANTA FE",
    descripcionSucursal: "SANTA FE",
    direccionSucursal: "SAN MARTIN 2515/25",
    idSucursal: "0210"
  },
  {
    numeroSucursal: "0212",
    provincia: "ENTRE RIOS",
    localidad: "CONCEP.DEL URUGUAY",
    descripcionSucursal: "CONCEPCION DEL URUGUAY",
    direccionSucursal: "9 DE JULIO 876",
    idSucursal: "0212"
  },
  {
    numeroSucursal: "0214",
    provincia: "GRAN BUENOS AIRES",
    localidad: "MAR DEL PLATA",
    descripcionSucursal: "GUEMES-MAR DEL PLATA",
    direccionSucursal: "GUEMES 2648",
    idSucursal: "0214"
  },
  {
    numeroSucursal: "0174",
    provincia: "CAPITAL FEDERAL",
    localidad: "PALERMO",
    descripcionSucursal: "BOTANICO",
    direccionSucursal: "SCALABRINI ORTIZ 2486/88",
    idSucursal: "0174"
  },
  {
    numeroSucursal: "0178",
    provincia: "CAPITAL FEDERAL",
    localidad: "PALERMO",
    descripcionSucursal: "AV.LAS HERAS",
    direccionSucursal: "AV. LAS HERAS 2332-40",
    idSucursal: "0178"
  },
  {
    numeroSucursal: "0215",
    provincia: "TUCUMAN",
    localidad: "S.M.DE TUCUMAN",
    descripcionSucursal: "TUCUMAN",
    direccionSucursal: "SAN MARTIN 622 ESQ. MENDOZA",
    idSucursal: "0215"
  },
  {
    numeroSucursal: "0179",
    provincia: "CAPITAL FEDERAL",
    localidad: "FLORES",
    descripcionSucursal: "AV.PEDRO GOYENA",
    direccionSucursal: "AV. PEDRO GOYENA 1192",
    idSucursal: "0179"
  },
  {
    numeroSucursal: "0182",
    provincia: "CAPITAL FEDERAL",
    localidad: "SAN TELMO",
    descripcionSucursal: "AV.BELGRANO",
    direccionSucursal: "BELGRANO 680-698",
    idSucursal: "0182"
  },
  {
    numeroSucursal: "0216",
    provincia: "CORRIENTES",
    localidad: "CORRIENTES",
    descripcionSucursal: "CIUDAD DE CORRIENTES",
    direccionSucursal: "CORDOBA 960",
    idSucursal: "0216"
  },
  {
    numeroSucursal: "0217",
    provincia: "NEUQUEN",
    localidad: "NEUQUEN",
    descripcionSucursal: "NEUQUEN",
    direccionSucursal: "AV. ARGENTINA 157",
    idSucursal: "0217"
  },
  {
    numeroSucursal: "0218",
    provincia: "CHACO",
    localidad: "RESISTENCIA",
    descripcionSucursal: "RESISTENCIA",
    direccionSucursal: "JOSE MARIA PAZ 66",
    idSucursal: "0218"
  },
  {
    numeroSucursal: "0219",
    provincia: "NEUQUEN",
    localidad: "SAN MARTIN DE LOS ANDES",
    descripcionSucursal: "SAN MARTIN DE LOS ANDES",
    direccionSucursal: "AV. SAN MARTIN 1093",
    idSucursal: "0219"
  },
  {
    numeroSucursal: "0184",
    provincia: "CAPITAL FEDERAL",
    localidad: "CABALLITO",
    descripcionSucursal: "AV.DIAZ VELEZ",
    direccionSucursal: "AV. DIAZ VELEZ 5253-65",
    idSucursal: "0184"
  },
  {
    numeroSucursal: "0223",
    provincia: "TUCUMAN",
    localidad: "YERBA BUENA",
    descripcionSucursal: "YERBA BUENA",
    direccionSucursal: "AV. ACONQUIJA 1620",
    idSucursal: "0223"
  },
  {
    numeroSucursal: "0225",
    provincia: "SANTIAGO DEL ESTERO",
    localidad: "LA BANDA",
    descripcionSucursal: "LA BANDA",
    direccionSucursal: "SARMIENTO 235/239",
    idSucursal: "0225"
  },
  {
    numeroSucursal: "0228",
    provincia: "TIERRA DEL FUEGO",
    localidad: "RIO GRANDE",
    descripcionSucursal: "RIO GRANDE",
    direccionSucursal: "AV. SAN MARTIN 165",
    idSucursal: "0228"
  },
  {
    numeroSucursal: "0230",
    provincia: "MENDOZA",
    localidad: "TUNUYAN",
    descripcionSucursal: "TUNUYAN",
    direccionSucursal: "AV. SAN MARTIN 1025",
    idSucursal: "0230"
  },
  {
    numeroSucursal: "0186",
    provincia: "CAPITAL FEDERAL",
    localidad: "BELGRANO",
    descripcionSucursal: "BELGRANO R",
    direccionSucursal: "ELCANO 3107/09",
    idSucursal: "0186"
  },
  {
    numeroSucursal: "0231",
    provincia: "GRAN BUENOS AIRES",
    localidad: "VILLA RAMALLO",
    descripcionSucursal: "VILLA RAMALLO",
    direccionSucursal: "AV. SAN MARTIN 621",
    idSucursal: "0231"
  },
  {
    numeroSucursal: "0234",
    provincia: "NEUQUEN",
    localidad: "VILLA LA ANGOSTURA",
    descripcionSucursal: "VILLA LA ANGOSTURA",
    direccionSucursal: "AV.ARRAYANES 90 (ESQ.CERRO BELVEDERE)L.3",
    idSucursal: "0234"
  },
  {
    numeroSucursal: "0235",
    provincia: "GRAN BUENOS AIRES",
    localidad: "MAR DEL PLATA",
    descripcionSucursal: "PUERTO",
    direccionSucursal: "12 DE OCTUBRE 3264",
    idSucursal: "0235"
  },
  {
    numeroSucursal: "0187",
    provincia: "CAPITAL FEDERAL",
    localidad: "MATADEROS",
    descripcionSucursal: "NUEVA MATADEROS",
    direccionSucursal: "AV. EVA PERON 4941",
    idSucursal: "0187"
  },
  {
    numeroSucursal: "0196",
    provincia: "CAPITAL FEDERAL",
    localidad: "CAPITAL FEDERAL",
    descripcionSucursal: "TORRE",
    direccionSucursal: "AV. CORDOBA 111",
    idSucursal: "0196"
  },
  {
    numeroSucursal: "0301",
    provincia: "CAPITAL FEDERAL",
    localidad: "ONCE",
    descripcionSucursal: "MISERERE",
    direccionSucursal: "AV. RIVADAVIA 2577/81",
    idSucursal: "0301"
  },
  {
    numeroSucursal: "0302",
    provincia: "CAPITAL FEDERAL",
    localidad: "RETIRO",
    descripcionSucursal: "NORTE",
    direccionSucursal: "URUGUAY 1031",
    idSucursal: "0302"
  },
  {
    numeroSucursal: "0236",
    provincia: "SALTA",
    localidad: "SALTA",
    descripcionSucursal: "TRES CERRITOS",
    direccionSucursal: "VIRREY TOLEDO 849",
    idSucursal: "0236"
  },
  {
    numeroSucursal: "0237",
    provincia: "MENDOZA",
    localidad: "MENDOZA",
    descripcionSucursal: "MENDOZA-CENTRO",
    direccionSucursal: "AV. ESPANA 1342",
    idSucursal: "0237"
  },
  {
    numeroSucursal: "0239",
    provincia: "GRAN BUENOS AIRES",
    localidad: "MAR DEL PLATA",
    descripcionSucursal: "AVENIDA CONSTITUCION",
    direccionSucursal: "AV. CONSTITUCION 4956",
    idSucursal: "0239"
  },
  {
    numeroSucursal: "0304",
    provincia: "CAPITAL FEDERAL",
    localidad: "RECOLETA",
    descripcionSucursal: "GRAND BOURG",
    direccionSucursal: "AV. DEL LIBERTADOR 2166",
    idSucursal: "0304"
  },
  {
    numeroSucursal: "0305",
    provincia: "CAPITAL FEDERAL",
    localidad: "RECOLETA",
    descripcionSucursal: "CALLAO",
    direccionSucursal: "AV. CALLAO 701",
    idSucursal: "0305"
  },
  {
    numeroSucursal: "0240",
    provincia: "MENDOZA",
    localidad: "MENDOZA",
    descripcionSucursal: "5TA. SECCION",
    direccionSucursal: "ARISTIDES VILLANUEVA 309",
    idSucursal: "0240"
  },
  {
    numeroSucursal: "0243",
    provincia: "MISIONES",
    localidad: "POSADAS",
    descripcionSucursal: "POSADAS",
    direccionSucursal: "COLON 1650",
    idSucursal: "0243"
  },
  {
    numeroSucursal: "0306",
    provincia: "CAPITAL FEDERAL",
    localidad: "ALMAGRO",
    descripcionSucursal: "ALMAGRO",
    direccionSucursal: "AV. LA PLATA 510",
    idSucursal: "0306"
  },
  {
    numeroSucursal: "0244",
    provincia: "CORDOBA",
    localidad: "CORDOBA",
    descripcionSucursal: "AV.COLON LA CANADA",
    direccionSucursal: "AV. COLON 406",
    idSucursal: "0244"
  },
  {
    numeroSucursal: "0247",
    provincia: "CORDOBA",
    localidad: "BARRIO SARMIENTO",
    descripcionSucursal: "BARRIO SARMIENTO",
    direccionSucursal: "AV. SABATTINI 2301",
    idSucursal: "0247"
  },
  {
    numeroSucursal: "0252",
    provincia: "CHUBUT",
    localidad: "Esquel",
    descripcionSucursal: "ESQUEL",
    direccionSucursal: "CALLE 9 NRO: 999 ESQ. 25 DE MAYO",
    idSucursal: "0252"
  },
  {
    numeroSucursal: "0307",
    provincia: "CAPITAL FEDERAL",
    localidad: "BELGRANO",
    descripcionSucursal: "BELGRANO",
    direccionSucursal: "MONROE 3099",
    idSucursal: "0307"
  },
  {
    numeroSucursal: "0308",
    provincia: "CAPITAL FEDERAL",
    localidad: "SAN CRISTOBAL",
    descripcionSucursal: "SAN CRISTOBAL",
    direccionSucursal: "AV. SAN JUAN 2654",
    idSucursal: "0308"
  },
  {
    numeroSucursal: "0253",
    provincia: "SANTA FE",
    localidad: "VENADO TUERTO",
    descripcionSucursal: "VENADO TUERTO",
    direccionSucursal: "SAN MARTIN 755",
    idSucursal: "0253"
  },
  {
    numeroSucursal: "0309",
    provincia: "CAPITAL FEDERAL",
    localidad: "VILLA PUEYRREDON",
    descripcionSucursal: "VILLA PUEYRREDON",
    direccionSucursal: "AV. MOSCONI 2816",
    idSucursal: "0309"
  },
  {
    numeroSucursal: "0256",
    provincia: "JUJUY",
    localidad: "S.S.DE JUJUY",
    descripcionSucursal: "JUJUY",
    direccionSucursal: "ALVEAR 992",
    idSucursal: "0256"
  },
  {
    numeroSucursal: "0313",
    provincia: "CAPITAL FEDERAL",
    localidad: "RECOLETA",
    descripcionSucursal: "ALVEAR",
    direccionSucursal: "AV. ALVEAR 1528",
    idSucursal: "0313"
  },
  {
    numeroSucursal: "0316",
    provincia: "CAPITAL FEDERAL",
    localidad: "RETIRO",
    descripcionSucursal: "CATALINAS",
    direccionSucursal: "AV. LEANDRO N. ALEM 996",
    idSucursal: "0316"
  },
  {
    numeroSucursal: "0317",
    provincia: "CAPITAL FEDERAL",
    localidad: "COLEGIALES",
    descripcionSucursal: "COLEGIALES",
    direccionSucursal: "FEDERICO LACROZE 2451/53",
    idSucursal: "0317"
  },
  {
    numeroSucursal: "0258",
    provincia: "RIO NEGRO",
    localidad: "S.C.BARILOCHE",
    descripcionSucursal: "BARILOCHE",
    direccionSucursal: "SAN MARTIN 336",
    idSucursal: "0258"
  },
  {
    numeroSucursal: "0259",
    provincia: "CORDOBA",
    localidad: "ALTA CORDOBA",
    descripcionSucursal: "ALTA CORDOBA",
    direccionSucursal: "JOSE B. BAIGORRI 799",
    idSucursal: "0259"
  },
  {
    numeroSucursal: "0318",
    provincia: "CAPITAL FEDERAL",
    localidad: "LINIERS",
    descripcionSucursal: "LINIERS",
    direccionSucursal: "AV. RIVADAVIA 11190",
    idSucursal: "0318"
  },
  {
    numeroSucursal: "0319",
    provincia: "CAPITAL FEDERAL",
    localidad: "MONSERRAT",
    descripcionSucursal: "MONTSERRAT",
    direccionSucursal: "MORENO 998",
    idSucursal: "0319"
  },
  {
    numeroSucursal: "0261",
    provincia: "MENDOZA",
    localidad: "RIVADAVIA",
    descripcionSucursal: "RIVADAVIA MZA.",
    direccionSucursal: "SAN ISIDRO 646",
    idSucursal: "0261"
  },
  {
    numeroSucursal: "0320",
    provincia: "CAPITAL FEDERAL",
    localidad: "SAN NICOLAS",
    descripcionSucursal: "AV. CORRIENTES",
    direccionSucursal: "AV. CORRIENTES 942",
    idSucursal: "0320"
  },
  {
    numeroSucursal: "0326",
    provincia: "CAPITAL FEDERAL",
    localidad: "CAPITAL FEDERAL",
    descripcionSucursal: "VILLA DEL PARQUE",
    direccionSucursal: "CUENCA 3401",
    idSucursal: "0326"
  },
  {
    numeroSucursal: "0262",
    provincia: "FORMOSA",
    localidad: "FORMOSA",
    descripcionSucursal: "FORMOSA",
    direccionSucursal: "AV. 25 DE MAYO 311",
    idSucursal: "0262"
  },
  {
    numeroSucursal: "0263",
    provincia: "GRAN BUENOS AIRES",
    localidad: "JUNIN",
    descripcionSucursal: "JUNIN",
    direccionSucursal: "BARTOLOME MITRE 81",
    idSucursal: "0263"
  },
  {
    numeroSucursal: "0264",
    provincia: "LA PAMPA",
    localidad: "SANTA ROSA",
    descripcionSucursal: "SANTA ROSA",
    direccionSucursal: "CARLOS PELLEGRINI 355",
    idSucursal: "0264"
  },
  {
    numeroSucursal: "0327",
    provincia: "CAPITAL FEDERAL",
    localidad: "ALMAGRO",
    descripcionSucursal: "PUEYRREDON",
    direccionSucursal: "AV. PUEYRREDON 1001",
    idSucursal: "0327"
  },
  {
    numeroSucursal: "0265",
    provincia: "LA RIOJA",
    localidad: "LA RIOJA",
    descripcionSucursal: "LA RIOJA",
    direccionSucursal: "SAN NICOLAS DE BARI 476",
    idSucursal: "0265"
  },
  {
    numeroSucursal: "0266",
    provincia: "CATAMARCA",
    localidad: "CATAMARCA",
    descripcionSucursal: "CATAMARCA",
    direccionSucursal: "RIVADAVIA 520",
    idSucursal: "0266"
  },
  {
    numeroSucursal: "0267",
    provincia: "CORDOBA",
    localidad: "RIO CUARTO",
    descripcionSucursal: "RIO CUARTO",
    direccionSucursal: "SOBREMONTE 695",
    idSucursal: "0267"
  },
  {
    numeroSucursal: "0269",
    provincia: "MENDOZA",
    localidad: "SAN MARTIN",
    descripcionSucursal: "GENERAL SAN MARTIN",
    direccionSucursal: "AVELLANEDA ESQ.B.SUR MER",
    idSucursal: "0269"
  },
  {
    numeroSucursal: "0270",
    provincia: "SAN LUIS",
    localidad: "SAN LUIS",
    descripcionSucursal: "SAN LUIS",
    direccionSucursal: "JOSE G. ARTIGAS 824",
    idSucursal: "0270"
  },
  {
    numeroSucursal: "0271",
    provincia: "SAN LUIS",
    localidad: "VILLA MERCEDES",
    descripcionSucursal: "VILLA MERCEDES",
    direccionSucursal: "PEDERNERA 524",
    idSucursal: "0271"
  },
  {
    numeroSucursal: "0272",
    provincia: "SANTA CRUZ",
    localidad: "RIO GALLEGOS",
    descripcionSucursal: "RIO GALLEGOS",
    direccionSucursal: "SARMIENTO 40",
    idSucursal: "0272"
  },
  {
    numeroSucursal: "0274",
    provincia: "CORDOBA",
    localidad: "VILLA CARLOS PAZ",
    descripcionSucursal: "VILLA CARLOS PAZ",
    direccionSucursal: "AV. GRAL. SAN MARTIN 65",
    idSucursal: "0274"
  },
  {
    numeroSucursal: "0275",
    provincia: "CORDOBA",
    localidad: "VILLA MARIA",
    descripcionSucursal: "VILLA MARIA",
    direccionSucursal: "GENERAL PAZ 45",
    idSucursal: "0275"
  },
  {
    numeroSucursal: "0276",
    provincia: "CORDOBA",
    localidad: "SAN FRANCISCO",
    descripcionSucursal: "SAN FRANCISCO",
    direccionSucursal: "AV. 25 DE MAYO 1591",
    idSucursal: "0276"
  },
  {
    numeroSucursal: "0328",
    provincia: "CAPITAL FEDERAL",
    localidad: "MATADEROS",
    descripcionSucursal: "MATADEROS",
    direccionSucursal: "AV. J. B. ALBERDI 6401",
    idSucursal: "0328"
  },
  {
    numeroSucursal: "0279",
    provincia: "MENDOZA",
    localidad: "SAN RAFAEL",
    descripcionSucursal: "SAN RAFAEL",
    direccionSucursal: "HIPOLITO YRIGOYEN 191",
    idSucursal: "0279"
  },
  {
    numeroSucursal: "0280",
    provincia: "GRAN BUENOS AIRES",
    localidad: "OLAVARRIA",
    descripcionSucursal: "OLAVARRIA",
    direccionSucursal: "NECOCHEA 3086",
    idSucursal: "0280"
  },
  {
    numeroSucursal: "0282",
    provincia: "SANTA FE",
    localidad: "ROSARIO",
    descripcionSucursal: "PASEO DEL SIGLO",
    direccionSucursal: "CORDOBA 1935",
    idSucursal: "0282"
  },
  {
    numeroSucursal: "0283",
    provincia: "MENDOZA",
    localidad: "LUJAN DE CUYO",
    descripcionSucursal: "LUJAN DE CUYO",
    direccionSucursal: "AV. SAN MARTIN 558",
    idSucursal: "0283"
  },
  {
    numeroSucursal: "0284",
    provincia: "MENDOZA",
    localidad: "MAIPU",
    descripcionSucursal: "MAIPU",
    direccionSucursal: "SAN MARTIN 198",
    idSucursal: "0284"
  },
  {
    numeroSucursal: "0285",
    provincia: "MENDOZA",
    localidad: "GODOY CRUZ",
    descripcionSucursal: "GODOY CRUZ",
    direccionSucursal: "AV. SAN MARTIN 926",
    idSucursal: "0285"
  },
  {
    numeroSucursal: "0286",
    provincia: "MENDOZA",
    localidad: "GUAYMALLEN",
    descripcionSucursal: "GUAYMALLEN",
    direccionSucursal: "AV. LIBERTAD 424",
    idSucursal: "0286"
  },
  {
    numeroSucursal: "0288",
    provincia: "GRAN BUENOS AIRES",
    localidad: "TRES ARROYOS",
    descripcionSucursal: "TRES ARROYOS",
    direccionSucursal: "COLON 301",
    idSucursal: "0288"
  },
  {
    numeroSucursal: "0289",
    provincia: "CORDOBA",
    localidad: "RIO TERCERO",
    descripcionSucursal: "RIO TERCERO",
    direccionSucursal: "S.MARTIN ESQ.V.SARSFIELD",
    idSucursal: "0289"
  },
  {
    numeroSucursal: "0290",
    provincia: "CORDOBA",
    localidad: "B.CERRO DE LAS ROSAS",
    descripcionSucursal: "CERRO DE LAS ROSAS",
    direccionSucursal: "AV. RAFAEL NUNEZ 4173",
    idSucursal: "0290"
  },
  {
    numeroSucursal: "0291",
    provincia: "CORDOBA",
    localidad: "CORDOBA",
    descripcionSucursal: "NUEVA CORDOBA",
    direccionSucursal: "ESTRADA 220",
    idSucursal: "0291"
  },
  {
    numeroSucursal: "0292",
    provincia: "RIO NEGRO",
    localidad: "CIPOLLETI",
    descripcionSucursal: "CIPOLLETTI",
    direccionSucursal: "ROCA 469",
    idSucursal: "0292"
  },
  {
    numeroSucursal: "0293",
    provincia: "GRAN BUENOS AIRES",
    localidad: "NECOCHEA",
    descripcionSucursal: "NECOCHEA",
    direccionSucursal: "CALLE 64 NRO 3041",
    idSucursal: "0293"
  },
  {
    numeroSucursal: "0329",
    provincia: "CAPITAL FEDERAL",
    localidad: "SAN NICOLAS",
    descripcionSucursal: "AV.DE MAYO",
    direccionSucursal: "AV. DE MAYO 1165",
    idSucursal: "0329"
  },
  {
    numeroSucursal: "0294",
    provincia: "SANTA FE",
    localidad: "VILLA CONSTITUCION",
    descripcionSucursal: "VILLA CONSTITUCION",
    direccionSucursal: "LISANDRO DE LA TORRE 380",
    idSucursal: "0294"
  },
  {
    numeroSucursal: "0295",
    provincia: "CHACO",
    localidad: "P.ROQUE SAENZ PENA",
    descripcionSucursal: "ROQUE SAENZ PENA",
    direccionSucursal: "SAN MARTIN 633 (CALLE 12)",
    idSucursal: "0295"
  },
  {
    numeroSucursal: "0296",
    provincia: "SANTA FE",
    localidad: "SAN LORENZO",
    descripcionSucursal: "SAN LORENZO",
    direccionSucursal: "SAN MARTIN 1102",
    idSucursal: "0296"
  },
  {
    numeroSucursal: "0330",
    provincia: "CAPITAL FEDERAL",
    localidad: "TRIBUNALES",
    descripcionSucursal: "TRIBUNALES",
    direccionSucursal: "AV. CORRIENTES 1401",
    idSucursal: "0330"
  },
  {
    numeroSucursal: "0297",
    provincia: "CHUBUT",
    localidad: "TRELEW",
    descripcionSucursal: "TRELEW",
    direccionSucursal: "BELGRANO 272",
    idSucursal: "0297"
  },
  {
    numeroSucursal: "0298",
    provincia: "CHUBUT",
    localidad: "PUERTO MADRYN",
    descripcionSucursal: "PUERTO MADRYN",
    direccionSucursal: "ROQUE SAENZ PENA 30",
    idSucursal: "0298"
  },
  {
    numeroSucursal: "0299",
    provincia: "TIERRA DEL FUEGO",
    localidad: "USHUAIA",
    descripcionSucursal: "USHUAIA",
    direccionSucursal: "MAIPU 65",
    idSucursal: "0299"
  },
  {
    numeroSucursal: "0311",
    provincia: "GRAN BUENOS AIRES",
    localidad: "VILLA BALLESTER",
    descripcionSucursal: "VILLA BALLESTER",
    direccionSucursal: "ALVEAR 26",
    idSucursal: "0311"
  },
  {
    numeroSucursal: "0314",
    provincia: "GRAN BUENOS AIRES",
    localidad: "VICENTE LOPEZ",
    descripcionSucursal: "VICENTE LOPEZ",
    direccionSucursal: "ALSINA 1496",
    idSucursal: "0314"
  },
  {
    numeroSucursal: "0321",
    provincia: "GRAN BUENOS AIRES",
    localidad: "AVELLANEDA",
    descripcionSucursal: "AVELLANEDA",
    direccionSucursal: "AV. MITRE 602",
    idSucursal: "0321"
  },
  {
    numeroSucursal: "0322",
    provincia: "GRAN BUENOS AIRES",
    localidad: "LANUS",
    descripcionSucursal: "LANUS",
    direccionSucursal: "AV. H. YRIGOYEN 4602",
    idSucursal: "0322"
  },
  {
    numeroSucursal: "0323",
    provincia: "GRAN BUENOS AIRES",
    localidad: "LOMAS DE ZAMORA",
    descripcionSucursal: "LOMAS DE ZAMORA",
    direccionSucursal: "LEANDRO N. ALEM 76",
    idSucursal: "0323"
  },
  {
    numeroSucursal: "0325",
    provincia: "GRAN BUENOS AIRES",
    localidad: "PILAR",
    descripcionSucursal: "PILAR",
    direccionSucursal: "ITUZAINGO 401",
    idSucursal: "0325"
  },
  {
    numeroSucursal: "0331",
    provincia: "GRAN BUENOS AIRES",
    localidad: "BOULOGNE",
    descripcionSucursal: "PANAMERICANA",
    direccionSucursal: "AV. ROLON 299",
    idSucursal: "0331"
  },
  {
    numeroSucursal: "0334",
    provincia: "GRAN BUENOS AIRES",
    localidad: "ITUZAINGO",
    descripcionSucursal: "ITUZAINGO",
    direccionSucursal: "24 DE OCTUBRE 876",
    idSucursal: "0334"
  },
  {
    numeroSucursal: "0332",
    provincia: "CAPITAL FEDERAL",
    localidad: "PALERMO",
    descripcionSucursal: "AV.SANTA FE",
    direccionSucursal: "AV. SANTA FE 2121",
    idSucursal: "0332"
  },
  {
    numeroSucursal: "0336",
    provincia: "GRAN BUENOS AIRES",
    localidad: "LA LUCILA",
    descripcionSucursal: "LA LUCILA",
    direccionSucursal: "AV. MAIPU 4164",
    idSucursal: "0336"
  },
  {
    numeroSucursal: "0337",
    provincia: "GRAN BUENOS AIRES",
    localidad: "MORON",
    descripcionSucursal: "MORON",
    direccionSucursal: "ALMIRANTE BROWN 965",
    idSucursal: "0337"
  },
  {
    numeroSucursal: "0338",
    provincia: "GRAN BUENOS AIRES",
    localidad: "BERAZATEGUI",
    descripcionSucursal: "BERAZATEGUI",
    direccionSucursal: "CALLE 14 NRO 4764",
    idSucursal: "0338"
  },
  {
    numeroSucursal: "0340",
    provincia: "GRAN BUENOS AIRES",
    localidad: "ZARATE",
    descripcionSucursal: "ZARATE",
    direccionSucursal: "BELGRANO 702",
    idSucursal: "0340"
  },
  {
    numeroSucursal: "0344",
    provincia: "GRAN BUENOS AIRES",
    localidad: "SAN MIGUEL",
    descripcionSucursal: "SAN MIGUEL",
    direccionSucursal: "AV.PRESIDENTE PERON 1226",
    idSucursal: "0344"
  },
  {
    numeroSucursal: "0347",
    provincia: "GRAN BUENOS AIRES",
    localidad: "MARTINEZ",
    descripcionSucursal: "MARTINEZ",
    direccionSucursal: "AV.SANTA FE 1860",
    idSucursal: "0347"
  },
  {
    numeroSucursal: "0351",
    provincia: "GRAN BUENOS AIRES",
    localidad: "BANFIELD",
    descripcionSucursal: "BANFIELD",
    direccionSucursal: "AV. H. YRIGOYEN 7853",
    idSucursal: "0351"
  },
  {
    numeroSucursal: "0353",
    provincia: "GRAN BUENOS AIRES",
    localidad: "ESCOBAR",
    descripcionSucursal: "ESCOBAR",
    direccionSucursal: "AV. MITRE 640",
    idSucursal: "0353"
  },
  {
    numeroSucursal: "0354",
    provincia: "GRAN BUENOS AIRES",
    localidad: "OLIVOS",
    descripcionSucursal: "OLIVOS",
    direccionSucursal: "AV. MAIPU 2894",
    idSucursal: "0354"
  },
  {
    numeroSucursal: "0361",
    provincia: "GRAN BUENOS AIRES",
    localidad: "LA PLATA",
    descripcionSucursal: "NUEVA LA PLATA",
    direccionSucursal: "CALLE 46 NRO. 565",
    idSucursal: "0361"
  },
  {
    numeroSucursal: "0367",
    provincia: "GRAN BUENOS AIRES",
    localidad: "MORENO",
    descripcionSucursal: "SHOPPING NINE",
    direccionSucursal: "AV.VICTORIA 1128",
    idSucursal: "0367"
  },
  {
    numeroSucursal: "0339",
    provincia: "CAPITAL FEDERAL",
    localidad: "VILLA URQUIZA",
    descripcionSucursal: "VILLA URQUIZA",
    direccionSucursal: "AV. TRIUNVIRATO 4274",
    idSucursal: "0339"
  },
  {
    numeroSucursal: "0341",
    provincia: "CAPITAL FEDERAL",
    localidad: "SAN NICOLAS",
    descripcionSucursal: "PUERTO VIAMONTE",
    direccionSucursal: "A.MOREAU DE JUSTO 228",
    idSucursal: "0341"
  },
  {
    numeroSucursal: "0342",
    provincia: "CAPITAL FEDERAL",
    localidad: "SAN NICOLAS",
    descripcionSucursal: "FLORIDA",
    direccionSucursal: "PERON JUAN DOMINGO TTE. GRAL.588",
    idSucursal: "0342"
  },
  {
    numeroSucursal: "0368",
    provincia: "GRAN BUENOS AIRES",
    localidad: "ESCOBAR",
    descripcionSucursal: "MASCHWITZ",
    direccionSucursal: "SANTIAGO DEL ESTERO 690",
    idSucursal: "0368"
  },
  {
    numeroSucursal: "0376",
    provincia: "CORDOBA",
    localidad: "GUALEGUAY",
    descripcionSucursal: "GUALEGUAY",
    direccionSucursal: "SAN ANTONIO 100",
    idSucursal: "0376"
  },
  {
    numeroSucursal: "0346",
    provincia: "CAPITAL FEDERAL",
    localidad: "SAN NICOLAS",
    descripcionSucursal: "CONGRESO",
    direccionSucursal: "AV. CALLAO 257/63",
    idSucursal: "0346"
  },
  {
    numeroSucursal: "0379",
    provincia: "CORDOBA",
    localidad: "CORDOBA",
    descripcionSucursal: "MARCOS JUAREZ",
    direccionSucursal: "AV. BELGRANO 930",
    idSucursal: "0379"
  },
  {
    numeroSucursal: "0381",
    provincia: "SAN JUAN",
    localidad: "Dpto. Rivadavia",
    descripcionSucursal: "RIVADAVIA SAN JUAN",
    direccionSucursal: "AV.LIBERTADOR SAN MARTIN N.3558",
    idSucursal: "0381"
  },
  {
    numeroSucursal: "0382",
    provincia: "GRAN BUENOS AIRES",
    localidad: "9 DE JULIO",
    descripcionSucursal: "9 DE JULIO",
    direccionSucursal: "HIPOLITO IRIGOYEN 921 - PROV. DE BS AS",
    idSucursal: "0382"
  },
  {
    numeroSucursal: "0383",
    provincia: "LA PAMPA",
    localidad: "GRAL. PICO",
    descripcionSucursal: "GENERAL PICO",
    direccionSucursal: "CALLE 22 N605 - GRAL.PICO",
    idSucursal: "0383"
  },
  {
    numeroSucursal: "0352",
    provincia: "CAPITAL FEDERAL",
    localidad: "BELGRANO",
    descripcionSucursal: "L.M.CAMPOS",
    direccionSucursal: "LUIS MARIA CAMPOS 1383",
    idSucursal: "0352"
  },
  {
    numeroSucursal: "0384",
    provincia: "GRAN BUENOS AIRES",
    localidad: "TRENQUE LAUQUEN",
    descripcionSucursal: "TRENQUE LAUQUEN",
    direccionSucursal: "AV.VILLEGAS 418",
    idSucursal: "0384"
  },
  {
    numeroSucursal: "0356",
    provincia: "CAPITAL FEDERAL",
    localidad: "NUÑEZ",
    descripcionSucursal: "NUNEZ",
    direccionSucursal: "AV. CABILDO 3622/24",
    idSucursal: "0356"
  },
  {
    numeroSucursal: "0357",
    provincia: "CAPITAL FEDERAL",
    localidad: "CAPITAL FEDERAL",
    descripcionSucursal: "ALVAREZ THOMAS",
    direccionSucursal: "ALVAREZ THOMAS 402/418",
    idSucursal: "0357"
  },
  {
    numeroSucursal: "0386",
    provincia: "CORDOBA",
    localidad: "ARROYITO",
    descripcionSucursal: "ARROYITO CORDOBA",
    direccionSucursal: "AVENIDA FULVIO PAGANI 1326",
    idSucursal: "0386"
  },
  {
    numeroSucursal: "0387",
    provincia: "CHUBUT",
    localidad: "COMODORO RIVADAVIA",
    descripcionSucursal: "NUEVA COMODORO RIVADAVIA",
    direccionSucursal: "HIPOLITO IRIGOYEN 2386",
    idSucursal: "0387"
  },
  {
    numeroSucursal: "0418",
    provincia: "SANTA FE",
    localidad: "SANTA FE",
    descripcionSucursal: "CANDIOTI",
    direccionSucursal: "BOULEVARD GALVEZ 1875",
    idSucursal: "0418"
  },
  {
    numeroSucursal: "0999",
    provincia: "CAPITAL FEDERAL",
    localidad: "SAN NICOLAS",
    descripcionSucursal: "CATEDRAL",
    direccionSucursal: "RECONQUISTA 2",
    idSucursal: "0999"
  },
  {
    numeroSucursal: "9999",
    provincia: "PRESCRIPTORES",
    localidad: "PRESCRIPTORES",
    descripcionSucursal: "PRESCRIPTORES",
    direccionSucursal: "PRESCRIPTORES",
    idSucursal: "9999"
  }
];

const franjasHorarias = [
  {
    label: "de 9 a 12 hs.",
    value: "de 9 a 12 hs."
  },
  {
    label: "de 12 a 15 hs.",
    value: "de 12 a 15 hs."
  },
  {
    label: "de 15 a 18 hs.",
    value: "de 15 a 18 hs."
  }
];

const nacionalidades = [
  { label: "ARGENTINA", value: "80" },
  { label: "AFGANISTAN", value: "65" },
  { label: "ALBANIA", value: "52" },
  { label: "ALEMANIA", value: "3" },
  { label: "ALTO VOLTA", value: "100" },
  { label: "ANDORRA", value: "101" },
  { label: "ANGOLA", value: "164" },
  { label: "ARABE SIRIA", value: "35" },
  { label: "ARABIA SAUDITA", value: "53" },
  { label: "ARGELIA", value: "102" },
  { label: "AUSTRALIA", value: "21" },
  { label: "AUSTRIA", value: "13" },
  { label: "BAHAMAS", value: "48" },
  { label: "BAHERIN", value: "149" },
  { label: "BANGLADESH", value: "165" },
  { label: "BARBADOS", value: "150" },
  { label: "BELGICA", value: "6" },
  { label: "BENIM", value: "113" },
  { label: "BHUTAN", value: "73" },
  { label: "BIRMANIA", value: "89" },
  { label: "BOLIVIA", value: "41" },
  { label: "BOTSWANA", value: "151" },
  { label: "BRASIL", value: "12" },
  { label: "BRUNEI", value: "174" },
  { label: "BULGARIA", value: "45" },
  { label: "BURUNDI", value: "104" },
  { label: "CABO VERDE", value: "172" },
  { label: "CAMERUM", value: "106" },
  { label: "CANADA", value: "17" },
  { label: "CENTRO AFRICANA", value: "107" },
  { label: "CHAD", value: "111" },
  { label: "CHECOSLOVAQUIA", value: "14" },
  { label: "CHILE", value: "11" },
  { label: "CHINA", value: "83" },
  { label: "CHIPRE", value: "112" },
  { label: "COLOMBIA", value: "54" },
  { label: "COMORAS", value: "184" },
  { label: "CONGO", value: "152" },
  { label: "COREA", value: "44" },
  { label: "COSTA DE MARFIL", value: "110" },
  { label: "COSTA RICA", value: "55" },
  { label: "CROACIA", value: "254" },
  { label: "CUBA", value: "51" },
  { label: "DINAMARCA", value: "15" },
  { label: "DJIBOUTIA", value: "185" },
  { label: "DOMINICA", value: "163" },
  { label: "DOMINICANA", value: "76" },
  { label: "ECUADOR", value: "47" },
  { label: "EGIPTO", value: "57" },
  { label: "EL SALVADOR", value: "58" },
  { label: "EMIRATOS ARABES", value: "153" },
  { label: "ESLOVENIA", value: "255" },
  { label: "ESPANIA", value: "9" },
  { label: "ESTADOS UNIDOS", value: "2" },
  { label: "ETIOPIA SOC", value: "59" },
  { label: "FIJI", value: "186" },
  { label: "FILIPINAS", value: "85" },
  { label: "FINLANDIA", value: "37" },
  { label: "FRANCIA", value: "4" },
  { label: "GABONESA", value: "114" },
  { label: "GAMBIA", value: "154" },
  { label: "GHANA", value: "115" },
  { label: "GRECIA", value: "38" },
  { label: "GRENADA", value: "162" },
  { label: "GUATEMALA", value: "61" },
  { label: "GUAYANA", value: "97" },
  { label: "GUINEA", value: "116" },
  { label: "GUINEA BISSAU", value: "92" },
  { label: "GUINEA ECUATORIAL", value: "155" },
  { label: "HAITI", value: "62" },
  { label: "HOLANDA", value: "8" },
  { label: "HONDURAS", value: "63" },
  { label: "HONG KONG", value: "183" },
  { label: "HUNGRIA", value: "34" },
  { label: "INDIA", value: "20" },
  { label: "INDONESIA", value: "90" },
  { label: "IRAK", value: "86" },
  { label: "IRAN", value: "36" },
  { label: "IRLANDA", value: "24" },
  { label: "ISLANDIA", value: "18" },
  { label: "ISRAEL", value: "39" },
  { label: "ITALIA", value: "7" },
  { label: "JAMAICA", value: "117" },
  { label: "JAPON", value: "19" },
  { label: "JORDANIA", value: "118" },
  { label: "KAMPUCHEA DEMOC.", value: "105" },
  { label: "KENIA", value: "119" },
  { label: "KUWAIT", value: "120" },
  { label: "LESOTHO", value: "166" },
  { label: "LIBANESA", value: "32" },
  { label: "LIBERIA", value: "64" },
  { label: "LIBIA", value: "122" },
  { label: "LIECHTENSTEIN", value: "123" },
  { label: "LITUANIA", value: "49" },
  { label: "LUXEMBURGO", value: "43" },
  { label: "MADAGASCAR", value: "124" },
  { label: "MALASIA", value: "156" },
  { label: "MALAWI", value: "157" },
  { label: "MALDIVAS", value: "167" },
  { label: "MALI", value: "125" },
  { label: "MALTA", value: "168" },
  { label: "MALTA (OR.MIL)", value: "171" },
  { label: "MARRUECOS", value: "126" },
  { label: "MAURICIO", value: "158" },
  { label: "MAURITANIA", value: "127" },
  { label: "MEXICO", value: "33" },
  { label: "MONACO", value: "129" },
  { label: "MONGOLIA", value: "128" },
  { label: "MONTENEGRO", value: "252" },
  { label: "MOZAMBIQUE", value: "187" },
  { label: "NAURU", value: "177" },
  { label: "NEPAL", value: "130" },
  { label: "NICARAGUA", value: "67" },
  { label: "NIGER", value: "131" },
  { label: "NIGERIA", value: "132" },
  { label: "NORUEGA", value: "28" },
  { label: "NUEVA CALEDONIA", value: "175" },
  { label: "NUEVA ZELANDIA", value: "22" },
  { label: "NVAS.HEBRIDAS", value: "96" },
  { label: "OMAN", value: "159" },
  { label: "PAKISTAN", value: "42" },
  { label: "PANAMA", value: "68" },
  { label: "PAPUA Y NVA.GUINEA", value: "169" },
  { label: "PARAGUAY", value: "69" },
  { label: "PERU", value: "26" },
  { label: "POLONIA", value: "30" },
  { label: "PORTUGAL", value: "16" },
  { label: "PTO.RICO", value: "66" },
  { label: "QATAR", value: "160" },
  { label: "REINO UNIDO", value: "1" },
  { label: "REPUBLICA DE ARMENIA", value: "250" },
  { label: "RUANDA", value: "133" },
  { label: "RUMANIA", value: "31" },
  { label: "SALOMON", value: "173" },
  { label: "SAN MARINO", value: "135" },
  { label: "SAN VICENTE Y LAS GRANADINAS", value: "170" },
  { label: "SANTA LUCIA", value: "178" },
  { label: "SANTA SEDE", value: "78" },
  { label: "SANTO TOME Y PRINCIPE", value: "179" },
  { label: "SENEGAL", value: "136" },
  { label: "SERBIA", value: "251" },
  { label: "SEYCHELLES", value: "188" },
  { label: "SIERRA LEONA", value: "137" },
  { label: "SINGAPUR", value: "182" },
  { label: "SOMALIA", value: "94" },
  { label: "SRI LANKA", value: "88" },
  { label: "SUDAFRICA", value: "23" },
  { label: "SUDAN", value: "138" },
  { label: "SUECIA", value: "27" },
  { label: "SUIZA", value: "5" },
  { label: "SURINAME", value: "199" },
  { label: "SURINAME,REPUBLICA DE", value: "139" },
  { label: "SWAZILANDIA", value: "180" },
  { label: "TAIWAN", value: "56" },
  { label: "TANZANIA", value: "161" },
  { label: "THAILANDIA", value: "140" },
  { label: "TOGOLEN", value: "141" },
  { label: "TONGA", value: "181" },
  { label: "TRINIDAD Y TOBAGO", value: "142" },
  { label: "TUNECINA", value: "143" },
  { label: "TURQUIA", value: "46" },
  { label: "U.R.S.S.", value: "40" },
  { label: "UCRANIA", value: "253" },
  { label: "UGANDA", value: "144" },
  { label: "URUGUAY", value: "10" },
  { label: "VENEZUELA", value: "79" },
  { label: "VIETNAM", value: "145" },
  { label: "YEMEN,REP.ARABE", value: "147" },
  { label: "YEMEN,REP.EMOC.", value: "148" },
  { label: "YUGOSLAVIA", value: "29" },
  { label: "ZAIRE", value: "108" },
  { label: "ZAMBIA", value: "109" },
  { label: "ZIMBAWE", value: "176" }
];

const codigosAreaPopulares = [
  { label: "11 - BUENOS AIRES", value: "11" },
  { label: "220 - MARCOS PAZ - BUENOS AIRES", value: "220" },
  { label: "221 - LA PLATA - BUENOS AIRES", value: "221" },
  { label: "223 - MAR DEL PLATA - BUENOS AIRES", value: "223" },
  {
    label: "230 - LOS CARDALES / PILAR / VILLA ROSA - BUENOS AIRES",
    value: "230"
  },
  { label: "236 - JUNIN - BUENOS AIRES", value: "236" },
  { label: "237 - GENERAL RODRIGUEZ / MORENO- BUENOS AIRES", value: "237" },
  { label: "249 - TANDIL - BUENOS AIRES", value: "249" },
  { label: "260 - MALARGÜE - MENDOZA", value: "260" },
  { label: "261 - LUJAN DE CUYO / MENDOZA - MENDOZA", value: "261" },
  { label: "264 - SAN JUAN - SAN JUAN", value: "264" },
  { label: "266 - SAN LUIS - SAN LUIS", value: "266" },
  { label: "280 - RAWSON / TRELEW / PUERTO MADRYN - CHUBUT", value: "280" },
  { label: "291 - BAHIA BLANCA - BUENOS AIRES", value: "291" },
  {
    label:
      "294 - EL BOLSON / SAN CARLOS DE BARILOCHE / VILLA LA ANGOSTURA - RIO NEGRO",
    value: "294"
  },
  { label: "297 - COMODORO RIVADAVIA / CALETA OLIVIA - CHUBUT", value: "297" },
  { label: "298 - GENERAL ROCA / VILLA REGINA - RIO NEGRO", value: "298" },
  { label: "299 - PLOTTIER - NEUQUEN", value: "299" },
  {
    label:
      "341 - ROSARIO / FUNES / VILLA GOBERNADOR GALVEZ / CAPITAN BERMUDEZ - SANTA FE",
    value: "341"
  },
  { label: "342 - SANTA FE", value: "342" },
  { label: "345 - CONCORDIA - ENTRE RIOS", value: "345" },
  { label: "348 - GARIN / INGENIERO MASCHWITZ - BUENOS AIRES", value: "348" },
  { label: "351 - CORDOBA - CORDOBA", value: "351" },
  { label: "353 - VILLA MARIA - CORDOBA", value: "353" },
  { label: "358 - RIO CUARTO - CORDOBA", value: "358" },
  { label: "364 - QUITILIPI - CHACO", value: "364" },
  { label: "376 - POSADAS - MISIONES", value: "376" },
  { label: "381 - SAN MIGUEL DE TUCUMAN - TUCUMAN", value: "381" },
  { label: "387 - SALTA", value: "387" },
  { label: "2202 - GONZALEZ CATAN - BUENOS AIRES", value: "2202" },
  {
    label: "2225 - SAN VICENTE / ALEJANDRO KORN - BUENOS AIRES",
    value: "2225"
  },
  { label: "2226 - CAÑUELAS - BUENOS AIRES", value: "2226" },
  { label: "2229 - JUAN MARIA GUTIERREZ - BUENOS AIRES", value: "2229" },
  { label: "2241 - CHASCOMUS - BUENOS AIRES", value: "2241" },
  { label: "2246 - SANTA TERESITA - BUENOS AIRES", value: "2246" },
  { label: "2252 - SAN CLEMENTE DEL TUYU - BUENOS AIRES", value: "2252" },
  { label: "2254 - PINAMAR - BUENOS AIRES", value: "2254" },
  { label: "2255 - VILLA GESELL - BUENOS AIRES", value: "2255" },
  { label: "2257 - MAR DE AJO / SAN BERNARDO - BUENOS AIRES", value: "2257" },
  { label: "2262 - NECOCHEA - BUENOS AIRES", value: "2262" },
  { label: "2284 - OLAVARRIA - BUENOS AIRES", value: "2284" },
  { label: "2291 - MIRAMAR - BUENOS AIRES", value: "2291" },
  { label: "2317 - 12 DE OCTUBRE - BUENOS AIRES", value: "2317" },
  {
    label: "2320 - JOSE C. PAZ / TORTUGUITAS / DEL VISO - BUENOS AIRES",
    value: "2320"
  },
  { label: "2345 - 25 DE MAYO - BUENOS AIRES", value: "2345" },
  { label: "2346 - CHIVILCOY - BUENOS AIRES", value: "2346" },
  { label: "2396 - PEHUAJO - BUENOS AIRES", value: "2396" },
  { label: "2477 - PERGAMINO - BUENOS AIRES", value: "2477" },
  { label: "2622 - TUNUYAN - MENDOZA", value: "2622" },
  { label: "2901 - USHUAIA - TIERRA DEL FUEGO", value: "2901" },
  { label: "2902 - EL CALAFATE - SANTA CRUZ", value: "2902" },
  { label: "2921 - MONTE HERMOSO - BUENOS AIRES", value: "2921" },
  { label: "2924 - SAN MIGUEL ARCANGEL - BUENOS AIRES", value: "2924" },
  { label: "2925 - GENERAL SAN MARTIN - BUENOS AIRES", value: "2925" },
  { label: "2934 - BALNEARIO LAS GRUTAS - RIO NEGRO", value: "2934" },
  { label: "2945 - ESQUEL - CHUBUT", value: "2945" },
  { label: "2964 - RIO GRANDE - TIERRA DEL FUEGO", value: "2964" },
  { label: "2966 - RIO GALLEGOS - SANTA CRUZ", value: "2966" },
  {
    label: "2972 - SAN MARTIN DE LOS ANDES / JUNIN DE LOS ANDES - NEUQUEN",
    value: "2972"
  },
  { label: "2983 - TRES ARROYOS - BUENOS AIRES", value: "2983" },
  { label: "3327 - BENAVIDEZ - BUENOS AIRES", value: "3327" },
  { label: "3329 - BARADERO - BUENOS AIRES", value: "3329" },
  { label: "3401 - PIAMONTE - SANTA FE", value: "3401" },
  { label: "3442 - CONCEPCION DEL URUGUAY - ENTRE RIOS", value: "3442" },
  { label: "3444 - GUALEGUAY - ENTRE RIOS", value: "3444" },
  { label: "3446 - GUALEGUAYCHU - ENTRE RIOS", value: "3446" },
  { label: "3447 - VILLA ELISA - ENTRE RIOS", value: "3447" },
  { label: "3456 - FEDERACION - ENTRE RIOS", value: "3456" },
  { label: "3462 - VENADO TUERTO - SANTA FE", value: "3462" },
  { label: "3487 - ZARATE - BUENOS AIRES", value: "3487" },
  { label: "3489 - CAMPANA - BUENOS AIRES", value: "3489" },
  { label: "3521 - AVELLANEDA - CORDOBA", value: "3521" },
  { label: "3541 - COSQUIN / VILLA CARLOS PAZ - CORDOBA", value: "3541" },
  { label: "3543 - RIO CEBALLOS - CORDOBA", value: "3543" },
  { label: "3544 - MINA CLAVERO - CORDOBA", value: "3544" },
  { label: "3546 - VILLA GENERAL BELGRANO - CORDOBA", value: "3546" },
  { label: "3548 - CAPILLA DEL MONTE - CORDOBA", value: "3548" },
  { label: "3718 - CLORINDA - FORMOSA", value: "3718" },
  { label: "3755 - OBERA - MISIONES", value: "3755" },
  { label: "3757 - PUERTO IGUAZU - MISIONES", value: "3757" },
  { label: "3777 - 9 DE JULIO - CORRIENTES", value: "3777" },
  { label: "3786 - ITUZAINGO - CORRIENTES", value: "3786" },
  { label: "3868 - ANIMAMA - SALTA", value: "3868" },
  { label: "3873 - SALVADOR MAZZA - SALTA", value: "3873" }
];

const tiposActividades = [
  { label: "Industria", value: "Industria" },
  { label: "Servicios", value: "Servicios" },
  { label: "Comercios", value: "Comercios" },
  { label: "Agro", value: "Agro" }
];

const rangosFacturacion = [
  {
    tipoActividad: ["-1"],
    value: "$33.000.000 a $50.000.000",
    label: "Más de $ 33.000.000"
  },
  {
    tipoActividad: ["-1"],
    value: "Hasta $33.000.000",
    label: "Menos de $ 33.000.000"
  },
  {
    tipoActividad: ["Industria", "Servicios", "Comercios"],
    value: "Más de $200.000.000",
    label: "Más de $ 200.000.000"
  },
  {
    tipoActividad: ["Industria", "Servicios", "Comercios"],
    value: "$50.000.000 a $200.000.000",
    label: "Menos de $ 200.000.000"
  },
  {
    tipoActividad: ["Agro"],
    value: "$50.000.000 a $200.000.000",
    label: "Más de $ 50.000.000"
  },
  {
    tipoActividad: ["Agro"],
    value: "Hasta $50.000.000",
    label: "Menos de $ 50.000.000"
  }
];

const horariosContacto = [
  {
    label: "LUNES A VIERNES DE 8 A 13 HS",
    value: "Lunes a Viernes de 8 a 13 hs"
  },
  {
    label: "LUNES A VIERNES DE 13 A 18 HS",
    value: "Lunes a Viernes de 13 a 18 hs"
  }
];

const cargosYAreas = [
  { label: "SOCIO / DUEÑO", value: "SOCIO / DUEÑO" },
  { label: "FIRMANTE / APODERADO", value: "FIRMANTE / APODERADO" },
  { label: "FINANZAS / ADMINISTRACION", value: "FINANZAS / ADMINISTRACION" },
  { label: "RECURSOS HUMANOS", value: "RECURSOS HUMANOS" },
  { label: "OTROS", value: "OTROS" }
];

const tipoDeCobro = [
  { label: "Presencial", value: "Presencial" },
  { label: "A distancia", value: "A distancia" },
  { label: "Presencial y a distancia", value: "Presencial y a distancia" }
];

const lugarDeCobro = [
  { label: "En un lugar fijo", value: "En un lugar fijo" },
  { label: "De manera ambulante", value: "De manera ambulante" }
];

const volumenDeOperaciones = [
  { label: "Menos de 20 por día", value: "Menos de 20 por día" },
  { label: "Más de 20 por día", value: "Más de 20 por día" }
];

export {
  byValue,
  tiposDocumento,
  estadosCiviles,
  provincias,
  situacionesLaborales,
  actividades,
  ocupaciones,
  ingresosNetos,
  sucursales,
  franjasHorarias,
  nacionalidades,
  codigosAreaPopulares,
  tiposActividades,
  rangosFacturacion,
  horariosContacto,
  cargosYAreas,
  tipoDeCobro,
  lugarDeCobro,
  volumenDeOperaciones
};
